<sb-dialog-header class="min-h-16" [showCloseButton]="showCloseButton">
  @if (showTitle) {
    <h4 class="m-0 flex gap-0.5 text-lg font-extrabold">
      <span class="text-brand">{{ 'Learn' | translate }}</span>
      <span class="text-default">Shiftbase</span>
    </h4>
  }

  @if (showBackButton) {
    <button sb-icon-button [color]="'transparent'" (click)="back.emit()">
      <sb-icon [name]="'chevron-left'" />
    </button>
  }

  @if (showProgressBar) {
    <sb-progress-bar class="w-48" [level]="(currentStep / totalSteps) * 100"></sb-progress-bar>
  }
</sb-dialog-header>
<sb-dialog-content>
  <div
    class="grid h-full grid-cols-1 items-center gap-4 pb-16"
    [ngClass]="{ 'lg:grid-cols-split-screen': !hideSidePanel, 'pl-24': hideSidePanel }"
  >
    <div
      [ngClass]="{
        'justify-self-left max-w-2xl': hideSidePanel,
        'lg:w-activation-main-panel justify-self-center max-w-full': !hideSidePanel
      }"
    >
      <ng-content select="[main-panel], main-panel"></ng-content>
    </div>
    @if (!hideSidePanel) {
      <div
        class="h-full items-center justify-center"
        [ngClass]="{
          'hidden lg:flex': !asidePanelAlwaysVisible,
          flex: asidePanelAlwaysVisible,
          'max-lg:order-first': flowOrder === DialogActivationFlowOrder.ASIDE_PANEL_FIRST
        }"
      >
        <ng-content select="[aside-panel], aside-panel"></ng-content>
      </div>
    }
  </div>
</sb-dialog-content>
